import { render, staticRenderFns } from "./account-fx-alert.vue?vue&type=template&id=087fc6ad&"
import script from "./account-fx-alert.vue?vue&type=script&lang=js&"
export * from "./account-fx-alert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports